import IPresupuestoHistorico from "../interfaces/PresupuestoHistorico";
import { get } from "./fetch";

export const getPresupuestoHistorico = async (code?: string): Promise<IPresupuestoHistorico[]> => {
  //Stored Procedure: SAP_Get_Lista_PresupuestadoxAnno OP:1 con parámetro 3 sin parámetro
  var result = await get(`/api/presupuesto/historico/${code ? code : ""}`);
  return result;
};
